(()=>{
  const init=root=>{
    if(!root||root.dataset.topfinelTabsInitialized==="true")return;
    root.dataset.topfinelTabsInitialized="true";
    const tabs=[...root.querySelectorAll("[data-topfinel-tab]")];
    const panels=[...root.querySelectorAll("[data-topfinel-panel]")];
    const shell=root.querySelector(".topfinel-product-tabs__content-shell");
    if(!tabs.length||!panels.length||!shell)return;
    const mobile=window.matchMedia("(max-width: 749px)");
    const reducedMotion=window.matchMedia("(prefers-reduced-motion: reduce)");
    const panelNodes=new Map();
    let phase="list";
    let activeTrigger=null;
    let lockedScrollY=0;
    let pageStyles=null;
    let transitionTimer=0;
    const duration=()=>reducedMotion.matches?1:280;
    const label=root.dataset.backLabel||"Back";

    const activate=(value,focus=false,scrollTab=true)=>{
      tabs.forEach(tab=>{
        const active=tab.dataset.tab===value;
        tab.setAttribute("aria-selected",String(active));
        tab.tabIndex=active?0:-1;
        if(active&&focus)tab.focus({preventScroll:true});
      });
      panels.forEach(panel=>panel.hidden=panel.dataset.tab!==value);
      const current=tabs.find(tab=>tab.dataset.tab===value);
      if(current&&scrollTab)current.scrollIntoView({behavior:"smooth",block:"nearest",inline:"nearest"});
      return current||null;
    };

    const mountPanel=(panel)=>{
      if(panelNodes.has(panel))return;
      const header=document.createElement("div");
      header.className="topfinel-product-tabs__detail-header";
      const back=document.createElement("button");
      back.type="button";
      back.className="topfinel-product-tabs__detail-back";
      back.setAttribute("aria-label",label);
      const icon=document.createElementNS("http://www.w3.org/2000/svg","svg");
      icon.setAttribute("viewBox","0 0 24 24");
      icon.setAttribute("fill","none");
      icon.setAttribute("aria-hidden","true");
      icon.setAttribute("focusable","false");
      const path=document.createElementNS("http://www.w3.org/2000/svg","path");
      path.setAttribute("d","M19 12H5m0 0 7 7m-7-7 7-7");
      path.setAttribute("stroke","currentColor");
      path.setAttribute("stroke-width","1.7");
      path.setAttribute("stroke-linecap","round");
      path.setAttribute("stroke-linejoin","round");
      icon.append(path);
      const text=document.createElement("span");
      text.textContent=label;
      back.append(icon,text);
      back.addEventListener("click",closeDetail);
      header.append(back);
      const body=document.createElement("div");
      body.className="topfinel-product-tabs__detail-body";
      const originalNodes=[...panel.childNodes];
      originalNodes.forEach(node=>body.append(node));
      panel.replaceChildren(header,body);
      panelNodes.set(panel,{header,body,back});
    };

    const mountPanels=()=>panels.forEach(mountPanel);
    const unmountPanels=()=>panels.forEach(panel=>{
      const structure=panelNodes.get(panel);
      if(!structure)return;
      const content=[...structure.body.childNodes];
      panel.replaceChildren(...content);
      panelNodes.delete(panel);
    });

    const lockPage=()=>{
      if(pageStyles)return;
      const body=document.body;
      const html=document.documentElement;
      lockedScrollY=window.scrollY;
      pageStyles={
        body:{position:body.style.position,top:body.style.top,left:body.style.left,right:body.style.right,width:body.style.width,overflow:body.style.overflow},
        html:{overflow:html.style.overflow}
      };
      body.classList.add("topfinel-pdp-detail-open");
      body.style.position="fixed";
      body.style.top=`-${lockedScrollY}px`;
      body.style.left="0";
      body.style.right="0";
      body.style.width="100%";
      body.style.overflow="hidden";
      html.style.overflow="hidden";
    };

    const unlockPage=()=>{
      if(!pageStyles)return;
      const body=document.body;
      const html=document.documentElement;
      const {body:bodyStyle,html:htmlStyle}=pageStyles;
      body.style.position=bodyStyle.position;
      body.style.top=bodyStyle.top;
      body.style.left=bodyStyle.left;
      body.style.right=bodyStyle.right;
      body.style.width=bodyStyle.width;
      body.style.overflow=bodyStyle.overflow;
      html.style.overflow=htmlStyle.overflow;
      body.classList.remove("topfinel-pdp-detail-open");
      pageStyles=null;
      window.scrollTo(0,lockedScrollY);
    };

    const clearTimer=()=>{if(transitionTimer){window.clearTimeout(transitionTimer);transitionTimer=0;}};
    const finishClose=()=>{
      clearTimer();
      root.classList.remove("topfinel-product-tabs--mobile-detail-open","topfinel-product-tabs--mobile-detail-entering");
      phase="list";
      unlockPage();
      if(activeTrigger?.isConnected)activeTrigger.focus({preventScroll:true});
    };
    const scheduleFallback=(expected)=>{
      clearTimer();
      transitionTimer=window.setTimeout(()=>{
        if(expected==="opening"&&phase==="opening")phase="open";
        if(expected==="closing"&&phase==="closing")finishClose();
      },duration()+80);
    };

    function closeDetail(){
      if(!mobile.matches||phase==="list"||phase==="closing")return;
      phase="closing";
      root.classList.remove("topfinel-product-tabs--mobile-detail-open");
      scheduleFallback("closing");
    }

    const openDetail=(tab)=>{
      if(!mobile.matches||!tab||phase!=="list")return false;
      mountPanels();
      activeTrigger=tab;
      const panel=panels.find(item=>item.dataset.tab===tab.dataset.tab);
      if(!panel)return false;
      activate(tab.dataset.tab,false,false);
      const structure=panelNodes.get(panel);
      if(structure)structure.body.scrollTop=0;
      lockPage();
      phase="opening";
      root.classList.add("topfinel-product-tabs--mobile-detail-entering");
      void shell.offsetWidth;
      window.requestAnimationFrame(()=>{
        if(phase!=="opening")return;
        root.classList.add("topfinel-product-tabs--mobile-detail-open");
        window.requestAnimationFrame(()=>{
          if(phase!=="opening")return;
          const structure=panelNodes.get(panel);
          if(structure){
            structure.body.scrollTop=0;
            structure.body.scrollTo({top:0,left:0,behavior:"instant"});
            structure.back.focus({preventScroll:true});
          }
          scheduleFallback("opening");
        });
      });
      return true;
    };

    const onTransitionEnd=event=>{
      if(event.target!==shell||event.propertyName!=="transform")return;
      if(phase==="opening"){clearTimer();phase="open";return;}
      if(phase==="closing")finishClose();
    };
    shell.addEventListener("transitionend",onTransitionEnd);

    const restoreDesktopStructure=()=>{
      if(phase!=="list"){
        clearTimer();
        root.classList.remove("topfinel-product-tabs--mobile-detail-open","topfinel-product-tabs--mobile-detail-entering");
        phase="list";
        unlockPage();
      }
      unmountPanels();
    };
    const syncViewport=()=>{
      if(mobile.matches)mountPanels();
      else restoreDesktopStructure();
    };

    const activateFromHash=()=>{
      const hash=window.location.hash.slice(1);
      const target=tabs.find(tab=>tab.dataset.topfinelAnchor===hash);
      if(!target)return false;
      if(mobile.matches){
        if(phase==="list")openDetail(target);
        else {activate(target.dataset.tab,false,false);const panel=panels.find(item=>item.dataset.tab===target.dataset.tab);const body=panel&&panelNodes.get(panel)?.body;if(body)body.scrollTop=0;}
        return true;
      }
      activate(target.dataset.tab);
      window.requestAnimationFrame(()=>target.scrollIntoView({behavior:"smooth",block:"start",inline:"nearest"}));
      return true;
    };

    tabs.forEach((tab,index)=>{
      tab.addEventListener("click",()=>{
        if(mobile.matches)openDetail(tab);
        else activate(tab.dataset.tab);
      });
      tab.addEventListener("keydown",event=>{
        const keys=mobile.matches?["ArrowUp","ArrowDown","Home","End"]:["ArrowLeft","ArrowRight","Home","End"];
        if(!keys.includes(event.key))return;
        event.preventDefault();
        let next=index;
        if(event.key==="ArrowDown"||event.key==="ArrowRight")next=(index+1)%tabs.length;
        if(event.key==="ArrowUp"||event.key==="ArrowLeft")next=(index-1+tabs.length)%tabs.length;
        if(event.key==="Home")next=0;
        if(event.key==="End")next=tabs.length-1;
        activate(tabs[next].dataset.tab,true,true);
      });
    });

    const onHashChange=activateFromHash;
    const onViewportChange=syncViewport;
    if(typeof mobile.addEventListener==="function")mobile.addEventListener("change",onViewportChange);
    else if(typeof mobile.addListener==="function")mobile.addListener(onViewportChange);
    window.addEventListener("hashchange",onHashChange);
    syncViewport();
    if(!activateFromHash()&&tabs[0])activate(tabs[0].dataset.tab,false,!mobile.matches);

    const onBlockSelect=event=>{
      const block=event.target.closest("[data-tab]");
      if(!block||!root.contains(block))return;
      const tab=tabs.find(item=>item.dataset.tab===block.dataset.tab);
      if(mobile.matches&&tab)openDetail(tab);
      else activate(block.dataset.tab);
    };
    if(window.Shopify&&window.Shopify.designMode)document.addEventListener("shopify:block:select",onBlockSelect);

    const cleanup=()=>{
      clearTimer();
      root.classList.remove("topfinel-product-tabs--mobile-detail-open","topfinel-product-tabs--mobile-detail-entering");
      phase="list";
      unlockPage();
      unmountPanels();
      window.removeEventListener("hashchange",onHashChange);
      if(typeof mobile.removeEventListener==="function")mobile.removeEventListener("change",onViewportChange);
      else if(typeof mobile.removeListener==="function")mobile.removeListener(onViewportChange);
      shell.removeEventListener("transitionend",onTransitionEnd);
      if(window.Shopify&&window.Shopify.designMode)document.removeEventListener("shopify:block:select",onBlockSelect);
      delete root.dataset.topfinelTabsInitialized;
    };
    const onSectionUnload=event=>{
      if(event.target===root||event.target.contains?.(root)){
        cleanup();
        document.removeEventListener("shopify:section:unload",onSectionUnload);
      }
    };
    document.addEventListener("shopify:section:unload",onSectionUnload);
  };
  const initAll=()=>document.querySelectorAll("[data-topfinel-product-tabs]").forEach(init);
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initAll,{once:true});
  else initAll();
  document.addEventListener("shopify:section:load",event=>{
    const root=event.target.querySelector("[data-topfinel-product-tabs]");
    if(root)init(root);
  });
})();
